export { }

declare global {
	interface globalThis {
		__options: any
	}
}